import { BannerApiResponse } from '../types/banner';
import HttpHelpers from './helpers';

const BannersApiEndpoints = {
  getBanners: (): Promise<BannerApiResponse> => HttpHelpers.unAuthenticatedAxios
    .get<BannerApiResponse>('/api/v1/banners')
    .then((response) => response.data),
};

export default BannersApiEndpoints;
